import type Konva from "konva";
import React from "react";

import { AssignNodeField } from "./_AssignNodeField";
import { AttachEventHandler } from "./_AttachEventHandler";
import { useInContainer } from "./_container-context";

export interface NodeConfig
	extends Pick<
		Konva.NodeConfig,
		"x" | "y" | "width" | "height" | "visible" | "listening" | "offsetX" | "offsetY" | "opacity"
	> {
	zIndex?: number;
	onClick?(event: Konva.KonvaEventObject<MouseEvent>): void;
	onMouseDown?(event: Konva.KonvaEventObject<MouseEvent>): void;
	onMouseUp?(event: Konva.KonvaEventObject<MouseEvent>): void;
	onMouseEnter?(event: Konva.KonvaEventObject<MouseEvent>): void;
	onMouseLeave?(event: Konva.KonvaEventObject<MouseEvent>): void;
	onMouseMove?(event: Konva.KonvaEventObject<MouseEvent>): void;
}

export interface NodeProps extends NodeConfig {
	instance: Konva.Node;
}

export const Node: React.FC<React.PropsWithChildren<NodeProps>> = ({
	instance,

	x,
	y,
	zIndex,
	width,
	height,
	visible,
	listening,
	offsetX,
	offsetY,
	opacity,

	onClick,
	onMouseDown,
	onMouseUp,
	onMouseEnter,
	onMouseLeave,
	onMouseMove,

	children,
}) => {
	useInContainer(instance);

	React.useLayoutEffect(
		() => () => {
			instance.destroy();
		},
		[instance],
	);

	return (
		<>
			{children}

			{x != null && <AssignNodeField instance={instance} method="x" value={x} />}
			{y != null && <AssignNodeField instance={instance} method="y" value={y} />}
			{zIndex != null && <AssignNodeField instance={instance} method="zIndex" value={zIndex} />}
			{width != null && <AssignNodeField instance={instance} method="width" value={width} />}
			{height != null && <AssignNodeField instance={instance} method="height" value={height} />}
			{visible != null && <AssignNodeField instance={instance} method="visible" value={visible} />}
			{listening != null && <AssignNodeField instance={instance} method="listening" value={listening} />}
			{offsetX != null && <AssignNodeField instance={instance} method="offsetX" value={offsetX} />}
			{offsetY != null && <AssignNodeField instance={instance} method="offsetY" value={offsetY} />}
			{opacity != null && <AssignNodeField instance={instance} method="opacity" value={opacity} />}

			{onClick != null && <AttachEventHandler handler={onClick} name="click" node={instance} />}
			{onMouseDown != null && <AttachEventHandler handler={onMouseDown} name="mousedown" node={instance} />}
			{onMouseUp != null && <AttachEventHandler handler={onMouseUp} name="mouseup" node={instance} />}
			{onMouseEnter != null && <AttachEventHandler handler={onMouseEnter} name="mouseenter" node={instance} />}
			{onMouseLeave != null && <AttachEventHandler handler={onMouseLeave} name="mouseleave" node={instance} />}
			{onMouseMove != null && <AttachEventHandler handler={onMouseMove} name="mousemove" node={instance} />}
		</>
	);
};
